// field-base.ts
import moment from 'moment';
import { translate } from '@jsverse/transloco';
import { SelectedFieldBlock } from './fields.dto';
import { Field } from './fields';

export function createBaseField(field: Field) {
  return {
    api_attribute: field.api_attribute ?? "",
    type_of: field.type_of ?? "tag",
    uuid: field.uuid ?? "0",
    field_required: field.field_required ?? "0",
    field_fontsize: field.field_fontsize ?? "14",
    field_style: field.field_style ?? "1",
    field_section: field.field_section ?? "",
    allow_multi_lines: field.allow_multi_lines ?? "0",
    placeholder: field.placeholder ?? "",
    name: field.name ?? "",
    description: field.description ?? "",
    selected_type: field.selected_type ?? "new_field",
    select_type_text: field.select_type_text ?? translate("Content new field (Template/Document - section) - Field name - New field"),
    selected_field_type_id: field.selected_field_type_id ?? "0",
    selected_field_role_id: field.selected_field_role_id ?? "0",
    selected_for_role_id: field.selected_for_role_id ?? "0",
    source: field.source ?? "SimpleSign",
    recipient_id: field.recipient_id ?? "0",
    role_name: field.role_name ?? "",
    validation_type: field.validation_type ?? "",
    validation: field.validation ?? {},
    calculation: field.calculation ?? "",
    tag_view: field.tag_view ?? "0",
    extra: field.extra ?? {},
    document_type_id: field.document_type_id ?? "0",
    field_info: field.field_info ?? FieldInfo.ME,
    enable_conditional: field.enable_conditional ?? 0,
    conditional: field.conditional ?? "",
    reverse_conditional: field.reverse_conditional ?? "",
    connected_parent_conditional_id: field.connected_parent_conditional_id ?? [],
    linked_conditional_id: field.linked_conditional_id ?? [],
    value: field.value ?? "",
    prefixid: field.prefixid ?? "0",
    column: field.column ?? "100",
    field_block: Number(field.field_block) ?? SelectedFieldBlock.PdfField,
    hidden: field.hidden ?? 0,
    created_at: moment().format(),
    updated_at: moment().format(),
    order: field.order ?? 0,
    api_field: field.api_field ?? "",
    is_locked: field.is_locked ?? 0, // 0 for unlocked, 1
    secret_hidden_field: field.secret_hidden_field ?? 0, // 0 for not hidden, 1 for hidden
    semi_hidden_field : field.semi_hidden_field  ?? 0, // 0 for not hidden, 1 for hidden
    field_invalid : field.field_invalid  ?? 0, // 1 for invalid, 0 for valid
    pinned_field : field.pinned_field  ?? 0, // 0 for not hidden, 1 for hidden
  };
}

export enum FieldInfo {
  ME = "me",
  RECIPIENT_FIELD = "recipient_field",
  CUSTOM_FIELD = "custom_field",
  DOCUMENT_FIELD = "document_field",
}